import mixpanel from 'mixpanel-browser';
import store from '../store';

const mixpanelService = {
  initialize(token, proxyDomain) {
    mixpanel.init(token, {
      api_host: proxyDomain
    });
  },

  // ── Meta Pixel ──────────────────────────────────────────────────────────

  initMetaPixel(pixelId, userId, email) {
    if (!pixelId) return;

    if (!window.fbq) {
      var n = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];

      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
    }

    if (userId && email) {
      window.fbq('init', pixelId, {
        external_id: String(userId),
        em: email.toLowerCase()
      });
    } else {
      window.fbq('init', pixelId);
    }

    window.fbq('track', 'PageView');
  },

  trackMetaPixel(eventName, data) {
    if (!window.fbq) return;
    if (this.$reject()) return;
    if (data) {
      window.fbq('track', eventName, data);
    } else {
      window.fbq('track', eventName);
    }
  },

  trackPage() {
    if (this.$reject()) return;
    var data = Object.assign(this.$getBaseObj(), { page_type: 'dashboard' });
    var name = 'page_view';
    mixpanel.track(name, data);
  },

  trackEvent(name, action, properties) {
    if (this.$reject()) return;
    try {
      var data = Object.assign(this.$getBaseObj(), properties || {});
      if (action) data.action = action;
      mixpanel.track(name, data);
    } catch {
      console.log('Error tracking mixpanel event: ', name, properties);
    }
  },

  peopleSetOnce(properties, userId) {
    if (this.$reject()) return;
    mixpanel.identify(userId);
    mixpanel.people.set_once(properties);
  },

  $getBaseObj() {
    // Viewport, not screen: Mixpanel's own $screen_height is the monitor, not the space the app gets.
    var obj = { viewport_width: window.innerWidth, viewport_height: window.innerHeight };
    if (store.state.config.route.meta?.iframe) obj.iframed = true;
    return obj;
  },

  $reject() {
    return localStorage.getItem('runas') !== null;
  }
};

export default mixpanelService;
